import styled from 'styled-components';

import { color, variable } from '../../helpers/style.helpers';

export const TableWrapper = styled.div`
  width: 100%;
  border: 1px solid ${color.grey.light};
  border-radius: ${variable.radii[8]};
`;

export const TableComp = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  white-space: nowrap;
`;

export interface TableProps {
  className?: string;
  /** Testing key */
  'data-test'?: string;
  children: React.ReactNode;
}

export function Table({ children, className, 'data-test': dataTest }: TableProps) {
  return (
    <TableWrapper data-test={dataTest} className={className}>
      <TableComp>{children}</TableComp>
    </TableWrapper>
  );
}
